/* custom header sticky code start */
  document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector(".header-wrapper");
  
    if (!header) {
      console.warn("Header wrapper not found.");
      return;
    }
  
    const updateBodyClass = () => {
      const headerTop = header.getBoundingClientRect().top;
      const screenWidth = window.innerWidth;
      
      let threshold;
  /*
      if (screenWidth >= 750) { // Desktop
        threshold = 48;
      } else if (screenWidth <= 749) { // Tablet
        threshold = 10;
      } else { // Mobile
        threshold = 10;
      }
  */
      if(screenWidth > 749){
        threshold = 48;
      }else{
        threshold = 10;
      }
      
      if (headerTop <= threshold) {
        //document.body.classList.add("header-sticky-custom");
      } else {
        //document.body.classList.remove("header-sticky-custom");
      }
    };
  
    // Run on scroll and resize
    window.addEventListener("scroll", updateBodyClass);
    window.addEventListener("resize", updateBodyClass);
  
    // Run on load
    updateBodyClass();
  });
/* custom header sticky code end */

/* Code for custom scrollor start */
/*
function initializeCustomScroll() {
  setTimeout(() => {
    const sliders = document.querySelectorAll(".custom_scroll_items");

    sliders.forEach((slider) => {
      const parent = slider.closest(".custom-scrollbar-wrap"); // Find the parent main container
      const prevButton = parent?.querySelector(".custom_prev");
      const nextButton = parent?.querySelector(".custom_next");

      let isDown = false;
      let startX;
      let scrollLeft;

      // Mouse Dragging Events
      function startDragging(e) {
        isDown = true;
        slider.classList.add("active");
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      }

      function stopDragging() {
        isDown = false;
        slider.classList.remove("active");
      }

      function dragMove(e) {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 1; // Increase speed
        slider.scrollLeft = scrollLeft - walk;
      }

      slider.addEventListener("mousedown", startDragging);
      slider.addEventListener("mouseleave", stopDragging);
      slider.addEventListener("mouseup", stopDragging);
      slider.addEventListener("mousemove", dragMove);

      // Move slider with buttons
      const slideAmount = slider.clientWidth * 0.8; // Adjust slide amount based on container size

      function slideLeft() {
        slider.scrollBy({ left: -slideAmount, behavior: "smooth" });
        setTimeout(updateButtonState, 500);
      }

      function slideRight() {
        slider.scrollBy({ left: slideAmount, behavior: "smooth" });
        setTimeout(updateButtonState, 500);
      }

      if (prevButton) prevButton.addEventListener("click", slideLeft);
      if (nextButton) nextButton.addEventListener("click", slideRight);

      // Update button states and handle scroll availability
      function updateButtonState() {
        if (!prevButton || !nextButton) return;

        const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
        const isScrollable = maxScrollLeft > 0;

        // Add or remove the `.scroll-disabled` class
        parent.classList.toggle("scroll-disabled", !isScrollable);

        // Update button states
        prevButton.classList.toggle("disabled", slider.scrollLeft <= 0);
        nextButton.classList.toggle("disabled", slider.scrollLeft >= maxScrollLeft);
      }

      // Attach event listener to update button state on scroll
      slider.addEventListener("scroll", updateButtonState);

      // Initial state update after DOM loads and on resize
      updateButtonState();
      window.addEventListener("resize", updateButtonState);
    });
  }, 500);
}
*/

// Call the function to initialize the custom scroll
function initializeCustomScroll() {
  setTimeout(() => {
    document.querySelectorAll(".custom-scrollbar-wrap").forEach((container) => {
      const slider = container.querySelector(".custom_scroll_items");
      const thumb = container.querySelector(".scroll-thumb");
      const track = container.querySelector(".custom-scrollbar");
      const prevButton = container.querySelector(".custom_prev");
      const nextButton = container.querySelector(".custom_next");

      if (!slider || !thumb || !track || !prevButton || !nextButton) return;

      let isDown = false;
      let startX;
      let scrollLeft;
      let isDragging = false;
      let startXThumb;

      // Mouse Dragging Events
      slider.addEventListener("mousedown", (e) => {
        isDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      document.addEventListener("mouseup", () => {
        isDown = false;
        container.classList.remove("active-scroll");
      });

      slider.addEventListener("mousemove", (e) => {
        if (!isDown) return;
        e.preventDefault();
        container.classList.add("active-scroll");
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 3;
        slider.scrollLeft = scrollLeft - walk;
        updateThumbPosition();
      });

      // Move slider with buttons
      const slideAmount = slider.clientWidth * 0.1;

      prevButton.addEventListener("click", () => {
        slider.scrollBy({ left: -slideAmount, behavior: "smooth" });
        setTimeout(updateThumbPosition, 500);
      });

      nextButton.addEventListener("click", () => {
        slider.scrollBy({ left: slideAmount, behavior: "smooth" });
        setTimeout(updateThumbPosition, 500);
      });

      // Update custom scrollbar thumb position
      function updateThumbPosition() {
        let scrollPercentage = slider.scrollLeft / (slider.scrollWidth - slider.clientWidth);
        thumb.style.left = scrollPercentage * (track.clientWidth - thumb.clientWidth) + "px";
        updateButtonState();
      }

      // Dragging custom scrollbar
      thumb.addEventListener("mousedown", (e) => {
        isDragging = true;
        startXThumb = e.clientX - thumb.offsetLeft;
      });

      document.addEventListener("mousemove", (e) => {
        if (!isDragging) return;
        container.classList.add("active-scroll");
        let newLeft = e.clientX - startXThumb;
        let maxLeft = track.clientWidth - thumb.clientWidth;

        if (newLeft < 0) newLeft = 0;
        if (newLeft > maxLeft) newLeft = maxLeft;

        thumb.style.left = newLeft + "px";

        let scrollPercentage = newLeft / maxLeft;
        slider.scrollLeft = scrollPercentage * (slider.scrollWidth - slider.clientWidth);
      });

      document.addEventListener("mouseup", () => {
        isDragging = false;
        container.classList.remove("active-scroll");
      });

      // Update button states based on scroll position
      function updateButtonState() {
        const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
        prevButton.classList.toggle("disabled", slider.scrollLeft <= 0);
        nextButton.classList.toggle("disabled", slider.scrollLeft >= maxScrollLeft);
        container.classList.toggle("scroll-disabled", maxScrollLeft <= 0);
      }

      // Attach event listener to update button state on scroll
      slider.addEventListener("scroll", updateThumbPosition);

      // Initial state update after DOM loads
      updateThumbPosition();
    });
  }, 500);
}


document.addEventListener("DOMContentLoaded", initializeCustomScroll);
window.addEventListener("resize", initializeCustomScroll);


/* Code for custom scrollor end */

/* Custom megamenu tab start */
const tabs = document.querySelectorAll(".tab-megamenu a");
    const tabContents = document.querySelectorAll(".mega-menu--tabcontent");

    tabs.forEach(tab => {
        tab.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent default link behavior

            // Remove active class from all tabs and tab contents
            tabs.forEach(t => t.classList.remove("active"));
            //tabContents.forEach(content => content.classList.remove("active"));
             tabContents.forEach((content, i) => {
                  content.classList.remove("active");
                  content.style.transform = i > this.getAttribute("data-index") ? "translateX(100%)" : "translateX(-100%)";
              });
            // Add active class to clicked tab
            this.classList.add("active");
            //this.style.transform = "translateX(0)";
            tabContents[this.getAttribute("data-index")].style.transform = "translateX(0)";

            // Get corresponding tab content and add active class
            const targetContent = document.querySelector(this.getAttribute("data-tab"));
            if (targetContent) {
                targetContent.classList.add("active");
                initializeCustomScroll();
            }
        });
    });
/* Custom megamenu tab end */

/* Custom megamenu mobile tab start */
const tabsMobile = document.querySelectorAll(".tab-megamenu-mobile a");
    const tabContentsMobile = document.querySelectorAll(".mega-menu--tabcontent-mobile");

    tabsMobile.forEach(tab => {
        tab.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent default link behavior

            // Remove active class from all tabs and tab contents
            tabsMobile.forEach(t => t.classList.remove("active"));
            //tabContentsMobile.forEach(content => content.classList.remove("active"));
             tabContentsMobile.forEach((content, i) => {
                  content.classList.remove("active");
                  content.style.transform = i > this.getAttribute("data-index") ? "translateX(100%)" : "translateX(-100%)";
              });
            // Add active class to clicked tab
            this.classList.add("active");
            //this.style.transform = "translateX(0)";
            tabContentsMobile[this.getAttribute("data-index")].style.transform = "translateX(0)";

            // Get corresponding tab content and add active class
            const targetContentMobile = document.querySelector(this.getAttribute("data-tab"));
            if (targetContentMobile) {
                targetContentMobile.classList.add("active");
                initializeCustomScroll();
            }
        });
    });
/* Custom megamenu mobile tab end */




/* marquee start */

const marqueeItems = document.querySelectorAll(".marquee-items");

marqueeItems.forEach((marquee) => {
  const direction = marquee.getAttribute("data-scroll-direction");
  const autoPlayed =
    marquee.getAttribute("data-scroll-auto") === "true" ? false : true;

  const isReversed =
    marquee.getAttribute("data-scroll-direction") === "true" ? true : false;

  const duration =
    parseFloat(marquee.getAttribute("data-scroll-duration")) || 1;

  const boxes = gsap.utils.toArray(marquee.querySelectorAll(".marquee-item"));

  const loop = horizontalLoop(boxes, {
    repeat: -1,
    speed: duration,
    paused: autoPlayed,
    reversed: isReversed
  });
});

/*
This helper function makes a group of elements animate along the x-axis in a seamless, responsive loop.

Features:
 - Uses xPercent so that even if the widths change (like if the window gets resized), it should still work in most cases.
 - When each item animates to the left or right enough, it will loop back to the other side
 - Optionally pass in a config object with values like "speed" (default: 1, which travels at roughly 100 pixels per second), paused (boolean),  repeat, reversed, and paddingRight.
 - The returned timeline will have the following methods added to it:
   - next() - animates to the next element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
   - previous() - animates to the previous element using a timeline.tweenTo() which it returns. You can pass in a vars object to control duration, easing, etc.
   - toIndex() - pass in a zero-based index value of the element that it should animate to, and optionally pass in a vars object to control duration, easing, etc. Always goes in the shortest direction
   - current() - returns the current index (if an animation is in-progress, it reflects the final index)
   - times - an Array of the times on the timeline where each element hits the "starting" spot. There's also a label added accordingly, so "label1" is when the 2nd element reaches the start.
 */
function horizontalLoop(items, config) {
  items = gsap.utils.toArray(items);
  config = config || {};
  let tl = gsap.timeline({
      repeat: config.repeat,
      paused: config.paused,
      defaults: { ease: "none" },
      onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)
    }),
    length = items.length,
    startX = items[0].offsetLeft,
    times = [],
    widths = [],
    xPercents = [],
    curIndex = 0,
    pixelsPerSecond = (config.speed || 1) * 100,
    snap = config.snap === false ? (v) => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
    totalWidth,
    curX,
    distanceToStart,
    distanceToLoop,
    item,
    i;
  gsap.set(items, {
    // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
    xPercent: (i, el) => {
      let w = (widths[i] = parseFloat(gsap.getProperty(el, "width", "px")));
      xPercents[i] = snap(
        (parseFloat(gsap.getProperty(el, "x", "px")) / w) * 100 +
          gsap.getProperty(el, "xPercent")
      );
      return xPercents[i];
    }
  });
  gsap.set(items, { x: 0 });
  totalWidth =
    items[length - 1].offsetLeft +
    (xPercents[length - 1] / 100) * widths[length - 1] -
    startX +
    items[length - 1].offsetWidth *
      gsap.getProperty(items[length - 1], "scaleX") +
    (parseFloat(config.paddingRight) || 0);
  for (i = 0; i < length; i++) {
    item = items[i];
    curX = (xPercents[i] / 100) * widths[i];
    distanceToStart = item.offsetLeft + curX - startX;
    distanceToLoop =
      distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
    tl.to(
      item,
      {
        xPercent: snap(((curX - distanceToLoop) / widths[i]) * 100),
        duration: distanceToLoop / pixelsPerSecond
      },
      0
    )
      .fromTo(
        item,
        {
          xPercent: snap(
            ((curX - distanceToLoop + totalWidth) / widths[i]) * 100
          )
        },
        {
          xPercent: xPercents[i],
          duration:
            (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond,
          immediateRender: false
        },
        distanceToLoop / pixelsPerSecond
      )
      .add("label" + i, distanceToStart / pixelsPerSecond);
    times[i] = distanceToStart / pixelsPerSecond;
  }
  function toIndex(index, vars) {
    vars = vars || {};
    Math.abs(index - curIndex) > length / 2 &&
      (index += index > curIndex ? -length : length); // always go in the shortest direction
    let newIndex = gsap.utils.wrap(0, length, index),
      time = times[newIndex];
    if (time > tl.time() !== index > curIndex) {
      // if we're wrapping the timeline's playhead, make the proper adjustments
      vars.modifiers = { time: gsap.utils.wrap(0, tl.duration()) };
      time += tl.duration() * (index > curIndex ? 1 : -1);
    }
    curIndex = newIndex;
    vars.overwrite = true;
    return tl.tweenTo(time, vars);
  }
  tl.next = (vars) => toIndex(curIndex + 1, vars);
  tl.previous = (vars) => toIndex(curIndex - 1, vars);
  tl.current = () => curIndex;
  tl.toIndex = (index, vars) => toIndex(index, vars);
  tl.times = times;
  tl.progress(1, true).progress(0, true); // pre-render for performance
  if (config.reversed) {
    tl.vars.onReverseComplete();
    tl.reverse();
  }
  return tl;
};
/* marquee start end */


/* slick slider */ 
/*
    let sliders = $('.multi_slider');
  if (sliders.length) {
    sliders.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: false,
        autoplay: false, 
        swipe: false,
        touchMove: false
    });

    $('.prev-btn').click(function () {
        sliders.slick('slickPrev');
    });

    $('.next-btn').click(function () {
        sliders.slick('slickNext');
    });

    function updateButtons() {
        let currentSlide = $('.single-testimonials-image-slider.multi_slider').slick('slickCurrentSlide') + 1;
        let currentPage = Math.ceil(currentSlide);
        
      let totalSlides = $('.single-testimonials-image-slider .slick-dots li').length;
      let totalPages = Math.ceil(totalSlides);
      let pagintionNo = '<span>'+ currentPage +'</span><span>/</span><span>'+ totalPages +'</span>'
      $('.multi-slider-number').html(pagintionNo);

      
        let firstSlider = sliders.first();
        $('.prev-btn').toggleClass('slick-disabled', firstSlider.slick('slickCurrentSlide') === 0);
        $('.next-btn').toggleClass('slick-disabled', firstSlider.slick('slickCurrentSlide') >= firstSlider.slick('getSlick').slideCount - firstSlider.slick('getSlick').options.slidesToShow);
    }

    sliders.on('afterChange', updateButtons);
    updateButtons(); 
    $('.multi_slider').on('click', '.slick-dots li', function () {
      let index = $(this).index();
      sliders.each(function() {
          $(this).slick('slickGoTo', index);
      });
    });
  }
  */

  function initializeSliders() {
  let sliders = $('.multi_slider');

  if (sliders.length) {
    // Destroy any previously initialized sliders before reinitializing
    sliders.each(function () {
      if ($(this).hasClass('slick-initialized')) {
        $(this).slick('unslick');
      }
    });

    sliders.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: false,
      autoplay: false,
      swipe: false,
      touchMove: false
    });

    $('.prev-btn').off('click').on('click', function () {
      sliders.slick('slickPrev');
    });

    $('.next-btn').off('click').on('click', function () {
      sliders.slick('slickNext');
    });

    function updateButtons() {
      let currentSlide = $('.single-testimonials-image-slider.multi_slider').slick('slickCurrentSlide') + 1;
      let totalSlides = $('.single-testimonials-image-slider .slick-dots li').length;
      let currentPage = Math.ceil(currentSlide);
      let totalPages = Math.ceil(totalSlides);

      let paginationNo = '<span>' + currentPage + '</span><span>/</span><span>' + totalPages + '</span>';
      $('.multi-slider-number').html(paginationNo);

      let firstSlider = sliders.first();
      $('.prev-btn').toggleClass('slick-disabled', firstSlider.slick('slickCurrentSlide') === 0);
      $('.next-btn').toggleClass('slick-disabled', firstSlider.slick('slickCurrentSlide') >= firstSlider.slick('getSlick').slideCount - firstSlider.slick('getSlick').options.slidesToShow);
    }

    sliders.on('afterChange', updateButtons);
    updateButtons();

    $('.multi_slider').off('click', '.slick-dots li').on('click', '.slick-dots li', function () {
      let index = $(this).index();
      sliders.each(function () {
        $(this).slick('slickGoTo', index);
      });
    });
  }
}

// Call on document ready
$(document).ready(function () {
  initializeSliders();
});

// Call on window resize
$(window).on('resize', function () {
  initializeSliders();
});

/* slick slider end */



/* smooth scroll to review */
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".product-media-review-icon > a").forEach((element) => {
    element.addEventListener("click", (e) => {
      e.preventDefault();

      // Select the target element
      const targetElement = document.querySelector('.shopify-app-block [data-oke-widget]');

      if (targetElement) {
        // Calculate height of announcement bar and section header
        const announcementBar = document.querySelector(".announcement-bar-section");
        const sectionHeader = document.querySelector(".section-header");

        const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
        const sectionHeaderHeight = sectionHeader ? sectionHeader.offsetHeight : 0;
        const totalOffset = announcementBarHeight + sectionHeaderHeight;

        // Get current scroll position
        const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY;

        // Scroll to the target element with offset
        window.scrollTo({
          top: targetPosition - totalOffset,
          behavior: "smooth"
        });
      }
    });
  });
});


    
  $(function(){
      var current = location.pathname;
      $('.collection-menu-item a').each(function(){
          var $this = $(this);
          // if the current path is like this link, make it active
          if($this.attr('href').indexOf(current) !== -1){
              $this.addClass('active');
          }
      })
  });

  /*Tab FAQ section custom JS */
function FaqTabCustom(){
    const headers = document.querySelectorAll(".faq-tabs-wrap .collapsible-tab-title");
    const contentSections = document.querySelectorAll(".collapsible-header-row");
    const screenWidthInner = window.innerWidth;
    if (screenWidthInner < 749) {
    threshold_inner = 180;
    } else if (screenWidthInner < 989) {
        threshold_inner = 195;
    } else {
        threshold_inner = 23;
    }

    // Scroll on click with offset and toggle active tab
    headers.forEach(header => {
        header.addEventListener("click", function () {
            const targetId = this.getAttribute("data-id");
            if (!targetId) return;

            const targetEl = document.getElementById(targetId);
            const announcementBar = document.querySelector('.announcement-bar-section');
            const sectionHeader = document.querySelector('.section-header');

            const offset = (announcementBar?.offsetHeight || 0) + (sectionHeader?.offsetHeight || 0) + threshold_inner;

            if (targetEl) {
                const elementTop = targetEl.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                    top: elementTop - offset,
                    behavior: "smooth"
                });
            }

            // Update active classes
            headers.forEach(h => h.classList.remove("active"));
            this.classList.add("active");
        });
    });

    // Observer to auto-highlight nav on scroll
    const observerOptions = {
        root: null,
        rootMargin: "-50% 0px -50% 0px", // Adjust sensitivity as needed
        threshold: 0
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const id = entry.target.getAttribute("id");
                headers.forEach(header => {
                    header.classList.toggle("active", header.getAttribute("data-id") === id);
                });
            }
        });
    }, observerOptions);

    contentSections.forEach(section => {
        observer.observe(section);
    });
}
FaqTabCustom();
window.addEventListener("resize", FaqTabCustom);


/* Custom Peoduct media gallary next/prev button code */

  document.addEventListener("click", function (event) {
  if (event.target.classList.contains("product-slider-button--next")) {
    document.querySelector(".product-slider-button--prev").classList.remove("disabled");
    navigateThumbnail("next", event.target);
  }

  if (event.target.classList.contains("product-slider-button--prev")) {
    document.querySelector(".product-slider-button--next").classList.remove("disabled");
    navigateThumbnail("prev", event.target);
  }
});

function navigateThumbnail(direction, button) {
  const thumbnailList = document.querySelector(".thumbnail-slider .thumbnail-list");
  if (!thumbnailList) return;

  const thumbnails = Array.from(thumbnailList.querySelectorAll("li"));
  const currentIndex = thumbnails.findIndex((li) =>
    li.querySelector(".thumbnail[aria-current='true']")
  );

  if (currentIndex === -1) return;

  let targetIndex = direction === "next" ? currentIndex + 1 : currentIndex - 1;
  const targetItem = thumbnails[targetIndex];

  if (targetItem) {
    // Click the target thumbnail
    targetItem.querySelector(".thumbnail").click();

    // Smooth scroll into view
    targetItem.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "center"
    });

    button.classList.remove("disabled");
  } else {
    button.classList.add("disabled");
  }
}


 
